// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__udIgS","top":"styles_top__14rFc"};